/**
 * Detect whether a business category should use transportation-specific
 * quote/booking flows (pickup / drop-off).
 */
export function isTransportationBusinessCategory(category: string | undefined | null): boolean {
  if (!category || typeof category !== 'string') return false;
  const lower = category.toLowerCase().trim();
  if (lower.includes('transportation')) return true;
  const normalized = lower.replace(/\s+/g, '_').replace(/&/g, 'and');
  return normalized === 'transportation' || normalized.startsWith('transportation_');
}
